<script>
	var utilities = require('../../utilities'),
		_ = require('underscore'),
		page = require('page'),
		userContext = require('core/userContext'),
		model = require('model/model'),
		classService = require('services/classService'),
		accountService = require('services/accountService');

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},

		data: function () {
			return {
				classes: null,
				addClassForm: {}
			};
		},

		modelData: ['userContext', 'gcAddon'],

		methods: {
			getClassList: function () {
				var self = this,
					promise;

				if (userContext.getStudentType() === 'clever') {
					promise = classService.getClassesFromCleverToken();
				} else {
					promise = classService.getClassesFromGoogleToken();
				}

				return promise.then(function (results) {
					self.classes = utilities.sortObjects(results.classes || results, 'n');
				});
			},

			switchClass: function (clazz) {
				if (userContext.getStudentType() === 'clever') {
					return accountService
						.initializeCleverUser({
							classCode: clazz.cc
						})
						.then(function (result) {
							userContext.initialize(
								_.extend(
									{
										type: 'clever'
									},
									result
								)
							);

							model.set('activeClass', clazz);

							page.redirect('/student');
						});
				} else {
					return accountService
						.initializeGoogleUser({
							classCode: clazz.cc,
							gcAddon: !!this.gcAddon
						})
						.then(function (result) {
							userContext.initialize(
								_.extend(
									{
										type: 'google'
									},
									result
								)
							);

							model.set('activeClass', clazz);

							page.redirect('/student');
						});
				}
			},

			addClass: function (data, cb) {
				var self = this,
					classCode = data.classCode;

				classService
					.checkClass({
						cc: classCode
					})
					.then(function (result) {
						if (result.rt === 'student') {
							accountService
								.initializeGoogleUser({
									classCode: classCode,
									gcAddon: !!self.gcAddon
								})
								.then(function (initializeGoogleUserResult) {
									userContext.setToken(initializeGoogleUserResult.token);

									model.set('activeClass', result);

									return self.getClassList().then(function (results) {
										utilities.closeModals();

										cb(null, initializeGoogleUserResult);
									});
								})
								.fail(cb);
						} else if (result.rt === 'teacher') {
							utilities.openModal('#sr-tr-redirect');

							self.$subscribeOnce('modal-closed', function (modalId) {
								if (modalId === 'sr-tr-redirect') {
									page('/student-authentication?classCode=' + classCode);
								}
							});

							cb(new Error());
						}
					})
					.catch(cb);
			}
		},

		mounted() {
			this.getClassList();
		}
	};
</script>
<template>
	<main class="main">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">My Classes</h1>
				<ul class="main-header-actions">
					<li v-if="userContext && !userContext.organization">
						<button
							data-modal="#add-class-mc"
							class="button -outline">
							+ Add a Class
						</button>
					</li>
				</ul>
			</div>
		</header>
		<div class="main-content wrapper">
			<div>
				<div
					class="padding-medium"
					style="border-bottom: 1px solid #d6dfe0">
					<span class="text-muted"><strong>Class</strong></span>
					<span
						v-if="userContext && !userContext.organization"
						class="text-muted text-right"
						style="float: right"
						><strong>Class Code</strong></span
					>
				</div>
				<div
					class="padding-medium"
					style="border-bottom: 1px solid #d6dfe0"
					v-for="clas in classes"
					:key="clas.n">
					<span
						><a
							href="#"
							v-progress-click="() => switchClass(clas)"
							><strong>{{ clas.n }}</strong></a
						></span
					>
					<span
						v-if="userContext && !userContext.organization"
						class="text-muted text-right"
						style="float: right"
						>{{ clas.cc }}</span
					>
					<div>{{ clas.name }}</div>
				</div>
			</div>
		</div>
		<div
			id="add-class-mc"
			class="modal"
			data-modal-window>
			<div class="modal-container">
				<div class="modal-window">
					<div class="modal-window-wrap">
						<button
							class="modal-close"
							data-modal-close>
							<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
						</button>
						<section class="modal-content">
							<header class="modal-content-header">
								<h2>Add a Class</h2>
							</header>
							<div class="modal-content-main">
								<form-submitter
									form-name="addClassForm"
									:form-data.sync="addClassForm"
									:submit-to="addClass"
									action="./"
									class="form"
									no-close-modal
									novalidate>
									<auto-form-row
										v-bind:data.sync="addClassForm.classCode"
										placeholder="Enter Class Code"
										row-class="labelHiddenVisually"
										type="classCode"
										required>
									</auto-form-row>
									<auto-form-row
										v-bind:all-valid="addClassForm.allValid"
										type="submit"
										row-class="-full-width">
										Continue
									</auto-form-row>
								</form-submitter>
							</div>
						</section>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>
